import type { z } from 'zod';

type StorageParserOptions = {
  logWarnings?: boolean;
};

/**
 * useWorkspaceStorage의 parser 옵션에서 사용하는 Zod 기반 검증 유틸리티
 * - localStorage에 잘못된 값이 저장된 경우 fallback으로 graceful degradation
 * - 검증 실패시 console.warn으로 디버깅 정보 제공
 */
export function createStorageParser<T>(
  schema: z.ZodType<T>,
  fallback?: T,
  options: StorageParserOptions = {},
): (value: string) => T | undefined {
  const { logWarnings = true } = options;

  return (value: string): T | undefined => {
    try {
      const parsed = JSON.parse(value);
      const result = schema.safeParse(parsed);

      if (result.success) {
        return result.data;
      }

      if (logWarnings) {
        console.warn(`[Storage Validation] Invalid value:`, {
          value: parsed,
          errors: result.error.issues,
          fallback: fallback ?? 'initialValue',
        });
      }

      return fallback;
    } catch {
      return undefined;
    }
  };
}
